import type { EnrollmentCreateSuccessResult } from './enrollmentCreateSuccessResult';

export interface EnrollmentCreateSuccess {
  /** 수강신청 일시 */
  enrolledAt: string;
  /** 생성된 수강신청 ID */
  enrollmentId: string;
  /** 수강신청 번호 */
  enrollmentNumber: string;
  result: EnrollmentCreateSuccessResult;
  /**
   * 수강 유효 기간
   * @nullable
   */
  validUntil?: string | null;
}
